import styled from "styled-components";

export const IconWrapper = styled("div")`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;
